import React from "react";
import { ReactCountryDropdown } from '../../common/country-dropdown';
import { countries, INVALID_TOKEN, OS_TYPES } from '../../common/constant';
import { validateContactData } from '../../common/validations';
import { browserName, fullBrowserVersion, osName } from 'react-device-detect';
import { nanoid } from 'nanoid';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import Loader from "../../common/loader";
import classNames from "classnames";
import { getCountryCodeFromDialCode1, getDialCodeFromCountryCode, removeAllLocalCache, removeLocalStorage } from "../../common/utils";

const isServer = typeof window === "undefined";

class AdvertiseWithUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first_name: "",
            last_name: "",
            phone_number: "",
            email: "",
            subject: "Advertisw with us",
            comments: "",
            phone_num_country_code: getDialCodeFromCountryCode(this.props.countryCode),
            height: "unset", // Setting height inside header and footer for sticky render
            errors: {},
            loader: false
        }
    }
    // Get height is call if component fully rendered
    componentDidMount() {
        this.setState({ height: this.getHeight(), phone_num_country_code: getDialCodeFromCountryCode(this.props.countryCode) })
    }
    
    getHeight = () => {
        if(!isServer) {
            let footerEl = document.getElementsByTagName("footer")[0];
            let navEl = document.getElementsByTagName("nav")[0];
            if(typeof footerEl !== "undefined" && typeof navEl !== "undefined") {
                return `calc(100vh - ${footerEl.offsetHeight+navEl.offsetHeight}px)`
            }
        }
    }
    // Input chnage handler based on event name and value
    handleChange = (e) => {
        const field = e.target.name;
        const val = e.target.value;
        let errors = this.state.errors;
        this.setState({ [field]: val });
        if (val !== '' && errors) {
            errors[field] = ''
        }
        this.setState({ errors })
    }

    // validate inputs on submit
    isValid() {
        const { errors, isValid } = validateContactData(this.state);
        if (!isValid) {
            this.setState({ errors });
        }
        return isValid;
    }

    sendContactForm = (e) => {
        if(this.isValid()) {
            this.setState({ loader: true })
            let data = {
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                telephone: this.state.phone_num_country_code+this.state.phone_number,
                email: this.state.email,
                subject: this.state.subject,
                comments: this.state.subject,
                customer_id: localStorage.getItem("customer_id")
            }
            this.props.sendContactForm(data, { pid: process.env.P_ID}).then(async res => {
                if(res.data.success) {
                    this.setState({ 
                        first_name: "",
                        last_name: "",
                        phone_number: "",
                        email: "",
                        subject: "",
                        comments: "",
                        phone_num_country_code: getDialCodeFromCountryCode(this.props.countryCode),
                     })
                } else {
                    if(res.data.message === INVALID_TOKEN) {
                        await removeAllLocalCache();
                        this.handleSubmit(e);
                    } else {
                        this.setState({ loader: false })
                    }
                }
            })
            this.setState({ loader: false })
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        if(this.isValid()) {
            this.setState({ errors: {}, loader: true });
            // If access token is not present in local storage, call salt key API
            let refresh_token = await localStorage.getItem("refresh_token");
            let client_secret = await localStorage.getItem("client_secret");
            let token = await localStorage.getItem("token");
            let expired_at = await localStorage.getItem("expired_at");
            // If token is not saved in localStorage, then get it from server using Salt Key API
            if(refresh_token != null && client_secret != null && token != null) {
                if(!moment().isBefore(moment(expired_at))) {
                    await this.props.getRefreshToken({
                        client_secret: client_secret,
                        refresh_token: refresh_token
                    });
                    this.sendContactForm(e);
                } else {
                    this.sendContactForm(e);
                }
            } else {
                let deviceToken = uuidv4();
                await localStorage.setItem("device_token", deviceToken);
                await this.props.getSaltKey({
                    p_id: process.env.P_ID,
                    os_type_id: OS_TYPES[osName],
                    pkey: process.env.P_KEY,
                    serial_number: "NA",
                    model: browserName,
                    version: fullBrowserVersion,
                    unique_id: nanoid(),
                    device_token: deviceToken
                });
                this.sendContactForm(e);
            }
        }
    }
    render() {
        const { phone_num_country_code, first_name, last_name, email, phone_number, subject, comments, errors, loader } = this.state;
        return (
            <React.Fragment>
                <div className="row justify-content-center mt-xl-5 mt-3 mb-5">
                    <div className="col-xxl-7 col-md-5 col-12">
                        <div className="text-md-start text-center">
                            <h1 className='ff-ember-lt'>Partner with Us</h1>
                            <h5 className='ff-ember-lt w-md-75 w-100'>Reach out to Us and Reach our Audience.</h5>
                        </div>
                        <br/><br/>
                        <div className="row text-md-start text-center">
                            <div className="col-lg-6 col-md-12 col-6 my-4">
                                <div className="d-flex flex-md-row flex-column justify-content-start">
                                    <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                        <button className='btn btn-warning rounded-pill'>
                                            <i className='bi bi-book display-6'/>
                                        </button>
                                    </div>
                                    <div className='text-md-start text-center mt-md-0 mt-4'>
                                        <h3 className='ff-ember-rg'>1.5 Billion</h3>
                                        <h6 className='ff-ember-lt'>View minutes per month</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-6 my-4">
                                <div className="d-flex flex-md-row flex-column justify-content-start">
                                    <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                        <button className='btn btn-warning rounded-pill'>
                                            <i className='bi bi-book display-6'/>
                                        </button>
                                    </div>
                                    <div className='text-md-start text-center mt-md-0 mt-4'>
                                        <h3 className='ff-ember-rg'>100%</h3>
                                        <h6 className='ff-ember-lt'>Viewability</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-6 my-4">
                                <div className="d-flex flex-md-row flex-column justify-content-start">
                                    <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                        <button className='btn btn-warning rounded-pill'>
                                            <i className='bi bi-book display-6'/>
                                        </button>
                                    </div>
                                    <div className='text-md-start text-center mt-md-0 mt-4'>
                                        <h3 className='ff-ember-rg'>90%</h3>
                                        <h6 className='ff-ember-lt'>Completion Rate</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-6 my-4">
                                <div className="d-flex flex-md-row flex-column justify-content-start">
                                    <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                        <button className='btn btn-warning rounded-pill'>
                                            <i className='bi bi-book display-6'/>
                                        </button>
                                    </div>
                                    <div className='text-md-start text-center mt-md-0 mt-4'>
                                        <h3 className='ff-ember-rg'>5+ hours</h3>
                                        <h6 className='ff-ember-lt'>Average View time per day</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-5 col-md-6 col-12 img-container">
                        <div className="p-xxl-4 p-lg-3 p-3">
                            <form onSubmit={this.handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 col-12 my-lg-3 my-md-2 my-1">
                                        <div className="form-group">
                                            <label>First name</label>
                                            <input
                                                placeholder=''
                                                type='text'
                                                name='first_name'
                                                value={first_name}
                                                onChange={this.handleChange}
                                                className={classNames('form-control mt-1', { 'is-invalid': errors.first_name })}
                                            />
                                            {errors.first_name && <span className="invalid-feedback">{errors.first_name}</span>}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-12 my-lg-3 my-md-2 my-1">
                                        <div className="form-group">
                                            <label>Last name</label>
                                            <input
                                                placeholder=''
                                                type='text'
                                                name='last_name'
                                                value={last_name}
                                                onChange={this.handleChange}
                                                className={classNames('form-control mt-1', { 'is-invalid': errors.last_name })}
                                            />
                                            {errors.last_name && <span className="invalid-feedback">{errors.last_name}</span>}
                                        </div>
                                    </div>
                                    <div className="col-12 my-lg-3 my-md-2 my-1">
                                        <div className="form-group">
                                            <label>E-Mail Address</label>
                                            <input
                                                placeholder=''
                                                name='email'
                                                type='email'
                                                value={email}
                                                onChange={this.handleChange}
                                                className={classNames('form-control mt-1', { 'is-invalid': errors.email })}
                                            />
                                            {errors.email && <span className="invalid-feedback">{errors.email}</span>}
                                        </div>
                                    </div>
                                    <div className="col-12 my-lg-3 my-md-2 my-1">
                                        <div className="form-group">
                                            <label>Phone Number with Country Code</label>
                                            <div className="form-group d-flex flex-row my-1">
                                                <ReactCountryDropdown 
                                                    onSelect={(e) => this.setState({ phone_num_country_code: e.dial_code })} 
                                                    countryCode={getCountryCodeFromDialCode1(phone_num_country_code)} 
                                                />
                                                <div className='w-100'>
                                                    <input
                                                        placeholder="Mobile number"
                                                        type="text"
                                                        name="phone_number"
                                                        value={phone_number}
                                                        onChange={this.handleChange}
                                                        className={classNames('form-control ms-1', { 'is-invalid': errors.phone_number })}
                                                    />
                                                    {errors.phone_number && <span className="invalid-feedback">{errors.phone_number}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-12 my-lg-3 my-md-2 my-1">
                                        <div className="form-group">
                                            <label>Select message subject</label>
                                            <select 
                                                className={classNames('form-control mt-1', { 'is-invalid': errors.subject })}
                                                name='subject'
                                                value={subject}
                                                onChange={this.handleChange}
                                            >
                                                <option value={"Account related issue"}>Account related issue</option>
                                                <option value={"Subscription issue"}>Subscription issue</option>
                                                <option value={"Preferred Channel unavailable"}>Preferred Channel unavailable</option>
                                                <option value={"Copyright and other legal concerns"}>Copyright and other legal concerns</option>
                                                <option value={"General suggestions"}>General suggestions</option>
                                            </select>
                                            {errors.subject && <span className="invalid-feedback">{errors.subject}</span>}
                                        </div>
                                    </div> */}
                                    <div className="col-12 my-lg-3 my-md-2 my-1">
                                        <div className="form-group">
                                            <label>Your message</label>
                                            <textarea 
                                                placeholder='Type your message'
                                                className={classNames('form-control mt-1', { 'is-invalid': errors.comments })}
                                                minLength={500}
                                                name='comments'
                                                rows={5}
                                                onChange={this.handleChange}
                                                value={comments}
                                            />
                                            {errors.comments && <span className="invalid-feedback">{errors.comments}</span>}
                                        </div>
                                    </div>
                                    <div className="col-12 my-lg-3 my-2">
                                        <div className="form-group">
                                            <button type='submit' className='btn btn-primary px-5'>Send</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            {loader && <Loader/>}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default AdvertiseWithUs;